export const related = [
  '/puzzles/urban-fresh-code',
  '/puzzles/atlantis-restaurant-downtown',
  '/puzzles',
];
export const quickAnswer =
  'Enter BDAC at the Atlantis restaurant register in The Park.';
export const sourceIds = ['powerpyx-hideouts'];

## Where to Find Atlantis in The Park

Use the Atlantis restaurant in The Park. This is separate from the Downtown restaurant.

## Atlantis Code

Enter **BDAC** at the register.

## What Opens After BDAC?

The hidden room becomes accessible. Collect its health-upgrade item.

## Code Not Working?

Check the restaurant's zone first. Downtown needs an object sequence instead of this code. At the Park register, confirm the letters are in the order B, D, A, C.
